import type { ComponentProps } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/lib/utils';

/**
 * The HyperTek prototype's tooltip (h-prototype `components/ui/tooltip.tsx`), class for class. Positioning is
 * floating-ui writing inline styles through CSSOM, which the production CSP allows. White on
 * `--h-secondary` (215 16% 47%) measures 4.70:1 with the WCAG 2.1 formula, AA for this 15 px text. A
 * tooltip only ever repeats a label that is already in the accessible name — never put information in it
 * that exists nowhere else.
 */
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

function TooltipContent({ className, sideOffset = 4, ...props }: ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'z-[100] overflow-hidden rounded-md bg-[hsl(var(--h-secondary))] px-3 py-1.5 text-xs text-white shadow-md',
          // A 100 ms fade after Radix's own delay, 80 ms out (styles/motion.css).
          'h-tip',
          className,
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
